import {
  Button,
  Divider,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Stack,
  Text,
} from '@chakra-ui/react';
import {
  NotificationCreateInput,
  NotificationType,
} from '@/client/services/api/graphql/gql/graphql';

import { ChevronDownIcon } from '@chakra-ui/icons';
import { Fragment } from 'react';
import { useAssignmentNotificationBuilder } from '../../hooks/useAssignmentNotificationBuilder';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface AssignmentNotificationTypeMenuProps {
  overdueIsDisabled: boolean;
}

export default function AssignmentNotificationTypeMenu({
  overdueIsDisabled,
}: AssignmentNotificationTypeMenuProps) {
  const { t } = useTranslation();
  const { notificationTypeOptions } = useAssignmentNotificationBuilder();
  const { setValue, watch } = useFormContext<NotificationCreateInput>();
  const { type } = watch();

  return (
    <Stack spacing={6}>
      <Stack spacing={2}>
        <Text variant="createLabel">{t('notifications.notificationType')}</Text>

        <Menu>
          <MenuButton
            as={Button}
            variant="createGoldOutline"
            textAlign="left"
            rightIcon={<ChevronDownIcon />}
          >
            {notificationTypeOptions.find((option) => option.value === type)?.label}
          </MenuButton>

          <MenuList
            paddingY={2}
            paddingX={4}
            border="1px solid"
            borderColor="warmNeutral.200"
            borderRadius="6px"
            minWidth={0}
            width="fit-content"
            maxHeight="300px"
            overflowY="auto"
          >
            {notificationTypeOptions.map((option, index) => (
              <Fragment key={option.value}>
                <MenuItem
                  key={option.value}
                  isDisabled={
                    overdueIsDisabled && option.value === NotificationType.AssignmentOverdueAssignee
                  }
                  fontSize="14px"
                  fontWeight={500}
                  borderRadius="4px"
                  _hover={{ backgroundColor: 'warmNeutral.100' }}
                  onClick={() => setValue('type', option.value)}
                >
                  {option.label}
                </MenuItem>

                {index !== notificationTypeOptions.length - 1 && (
                  <MenuDivider color="warmNeutral.200" />
                )}
              </Fragment>
            ))}
          </MenuList>
        </Menu>
      </Stack>

      <Divider />
    </Stack>
  );
}
